module.exports = __webpack_public_path__ + "img/nav.3b6add8c.svg";